/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import UiTableSkeletonRowsList from './UiTableSkeletonComponents/UiTableSkeletonRowsList'

type UiTableSkeletonProps = {
    rows: number
    colSpan: number
    className?: string
}

const UiTableSkeleton: React.FC<UiTableSkeletonProps> = ({
    rows,
    colSpan,
    className,
}) => {
    return (
        <UiTableSkeletonRowsList
            rows={rows}
            colSpan={colSpan}
            className={className}
        />
    )
}

export default UiTableSkeleton
